import { CardHeading } from "./cardHeading";
import { GroupCardCancelled } from "./groupCardCancelled";
import styles from "./groupCard.module.scss";
import clsx from "clsx";
import { Text } from "@medoma/components/Text/Text";
import { AssigneeList } from "./assigneeList";
import { groupStatusSchema } from "@medoma/models/activities";
import { timeOfDaySchema } from "@medoma/models/activities";
import { activityCategoryDictionary } from "@/api/activities";
import { useLingui } from "@lingui/react/macro";
import { TravellingToTag } from "./travellingToTag/travellingToTag";
import { humanFormat } from "@medoma/models/date-and-time";
import { isAssigned, type IGroup } from "@/api/schedule";

export const GroupCard = ({ group }: { group: IGroup }) => {
  const { t } = useLingui();
  const { start, end, timeOfDay } = group;
  const isCancelled = group.visitStatus === groupStatusSchema.enum.cancelled;

  const startTime = start ? humanFormat(start, { timeStyle: "short" }) : null;
  const endTime = end ? humanFormat(end, { timeStyle: "short" }) : null;

  const timeSpanText =
    timeOfDay === timeOfDaySchema.enum.Any
      ? t`Under dagen`
      : startTime && endTime
        ? t`Mellan ${startTime} och ${endTime}`
        : null;

  if (isCancelled) {
    return (
      <article className={clsx(styles.groupCard, styles.cancelled)}>
        <GroupCardCancelled
          timeSpanText={timeSpanText}
          occurrenceCount={group.occurrences.length}
          category={group.category}
        />
      </article>
    );
  }

  const groupWithAssignedEmployees = {
    ...group,
    assignees: group.assignees.filter(isAssigned),
  };
  const groupHasAssignedEmployees =
    groupWithAssignedEmployees.assignees.length > 0;
  const isTravellingTo =
    group.visitStatus === groupStatusSchema.enum.travellingTo;

  return (
    <article className={styles.groupCard}>
      <CardHeading
        category={group.category}
        title={t(activityCategoryDictionary[group.category])}
        formattedTimespan={timeSpanText}
      />
      <ul>
        {group.occurrences.map((occurrence) => (
          <li key={`${occurrence.activityId}${occurrence.id}`}>
            <Text element="span" weight="regular" size="small">
              {occurrence.title}
            </Text>
          </li>
        ))}
      </ul>
      {groupHasAssignedEmployees ? (
        <AssigneeList assignees={groupWithAssignedEmployees.assignees} />
      ) : null}
      {isTravellingTo ? <TravellingToTag /> : null}
    </article>
  );
};
